<template>
  <file-card
    ref="$modal"
    @on-close="isActive = false"
    :position="safePosition"
    :loading="isLoading"
    height="auto"
    width="235px"
  >
    <div class="contact-info">
      <template v-if="type == 'move'">
        <div class="contact-info__header">{{ $t("confirm_move_elements_title") }}</div>
        <div class="contact-info__field">
          <div class="contact-info__field--text">
            {{ $t("confirm_move_prefix") }}
            <span class="contact-info__field--text-weight"> {{ label }} </span>
            {{ $t("file_move_to_folder") }}
            <span class="contact-info__field--text-weight">
              {{ targetDir?.Name }}
            </span>
          </div>
          <div class="contact-info__field--buttons">
            <app-button type="secondary" :label="$t('cancel_short')" @click="onClose" />
            <app-button type="primary" :label="$t('confirm_short')" @click="success" />
          </div>
        </div>
      </template>
      <template v-if="type == 'replace'">
        <div class="contact-info__header">{{ $t("file_replacement") }}</div>
        <div class="contact-info__field">
          <div class="contact-info__field-radio">
            <app-radio-button
              v-model="selectedReplaceOption"
              :text="$t('file_keep_current_name')"
              name="answer"
              :radio-value="true"
            />
            <app-radio-button
              v-model="selectedReplaceOption"
              :text="$t('file_apply_new_name')"
              name="answer"
              :radio-value="false"
            />
          </div>
          <div
            class="contact-info__field--buttons"
            style="justify-content: center"
          >
            <app-button type="secondary" :label="$t('cancel_short')" @click="onClose" />
            <app-button type="primary" :label="$t('file_replace')" @click="success" />
          </div>
        </div>
      </template>
      <template v-if="type == 'replaceUpload'">
        <div class="contact-info__header">
          {{ $t("file_name_exists") }}
        </div>
        <div class="contact-info__field">
          <div class="contact-info__field-radio">
            <app-radio-button
              v-model="selectedReplaceOption"
              :text="$t('file_replace_file')"
              name="answer"
              :radio-value="true"
            />
            <app-radio-button
              v-model="selectedReplaceOption"
              :text="$t('file_keep_both_versions')"
              name="answer"
              :radio-value="false"
            />
          </div>
          <div class="contact-info__field--buttons">
            <app-button type="secondary" :label="$t('cancel_short')" @click="onClose" />
            <app-button type="primary" :label="$t('confirm_short')" @click="success" />
          </div>
        </div>
      </template>
      <template v-if="type == 'error'">
        <div class="contact-info__header">{{ $t("file_error") }}</div>
        <div class="contact-info__field">
          <div
            style="align-self: center; max-width: 204px"
            class="contact-info__field--text"
          >
            {{ errorText }}
          </div>
          <div style="align-self: center" class="contact-info__field--buttons">
            <app-button type="primary" :label="$t('file_ok')" @click="success" />
          </div>
        </div>
      </template>
      <template v-if="type == 'remove'">
        <div class="contact-info__header">{{ $t("confirm_delete_elements_title") }}</div>
        <div class="contact-info__field">
          <div class="contact-info__field--text">
            {{ $t("confirm_delete_prefix") }}
            <span class="contact-info__field--text-weight">
              {{ label }}
            </span>
          </div>
          <div class="contact-info__field--buttons">
            <app-button type="secondary" :label="$t('cancel_short')" @click="onClose" />
            <app-button type="primary" :label="$t('confirm_short')" @click="success" />
          </div>
        </div>
      </template>
      <template v-if="type == 'removeFile'">
        <div class="contact-info__header">{{ $t("file_delete_file_title") }}</div>
        <div class="contact-info__field">
          <div class="contact-info__field--text">
            {{ $t("file_delete_file_prefix") }}
            <span class="contact-info__field--text-weight">
              {{ targetFile?.Name
              }}<span
                v-if="targetFile?.JobBindings.length > 0"
                style="font-weight: 400; color: #4d4d4d"
                >.</span
              >
            </span>
            {{
              targetFile?.JobBindings.length > 0
                ? $t(
                    targetFile?.JobBindings.length === 1
                      ? "file_attached_job"
                      : "file_attached_jobs",
                    { count: targetFile?.JobBindings.length },
                  )
                : ""
            }}
          </div>
          <div class="contact-info__field--buttons">
            <app-button type="secondary" :label="$t('cancel_short')" @click="onClose" />
            <app-button type="primary" :label="$t('confirm_short')" @click="success" />
          </div>
        </div>
      </template>
      <template v-if="type == 'removeFolder'">
        <div class="contact-info__header">{{ $t("file_delete_folder_title") }}</div>
        <div class="contact-info__field">
          <div class="contact-info__field--text">
            {{ $t("file_delete_folder_prefix") }}
            <span class="contact-info__field--text-weight">
              {{ targetDir?.Name }}
            </span>
          </div>
          <div class="contact-info__field--buttons">
            <app-button type="secondary" :label="$t('cancel_short')" @click="onClose" />
            <app-button type="primary" :label="$t('confirm_short')" @click="success" />
          </div>
        </div>
      </template>
      <template v-if="type == 'abortFile'">
        <div class="contact-info__header">{{ $t("file_abort_upload_title") }}</div>
        <div class="contact-info__field">
          <div class="contact-info__field--text">
            {{ $t("file_abort_upload_prefix") }}
            <span class="contact-info__field--text-weight">
              {{ targetFile?.Name }}
            </span>
          </div>
          <div class="contact-info__field--buttons">
            <app-button type="secondary" :label="$t('cancel_short')" @click="onClose" />
            <app-button type="primary" :label="$t('confirm_short')" @click="success" />
          </div>
        </div>
      </template>
    </div>
  </file-card>
</template>

<script setup lang="ts">
import FileCard from "./FileCard.vue";
import { computed, nextTick, onMounted, onUnmounted, ref } from "vue";
import AppButton from "@/components/ui-kit/button/AppButton.vue";
import AppRadioButton from "@/components/ui-kit/radio-button/AppRadioButton.vue";
import {
  FileOut,
  FolderOut,
} from "@/models/interfaces/file/file-model";
import { i18n } from "@/i18n";
import { useBreakpoints } from "@/composables/useBreakpoints";

const emit = defineEmits([
  "successMove",
  "successReplace",
  "successReplaceUpload",
  "successRemove",
  "successRemoveFile",
  "successRemoveFolder",
  "successAbortFile",
  "closeError",
]);

type ModalPosition = { x: number; y: number };

const selectedReplaceOption = ref<boolean>(true);

const $modal = ref<InstanceType<typeof FileCard> | null>(null);
const isLoading = ref(false);
const isActive = ref(false);
const targetDir = ref<FolderOut>();
const targetFile = ref<FileOut>();
const countEl = ref();
const errorText = ref("");
interface Props {
  type?:
    | "replace"
    | "move"
    | "error"
    | "replaceUpload"
    | "remove"
    | "removeFile"
    | "removeFolder"
    | "abortFile";
  errorType?: string;
  position?: ModalPosition | null;
}

const props = withDefaults(defineProps<Props>(), {
  type: "move",
  errorType: "size",
});

const { isMobile } = useBreakpoints();

const pluralize = (
  n: number,
  one: string,
  few: string,
  many: string,
): string => {
  const abs = Math.abs(n) % 100;
  const mod10 = abs % 10;
  if (abs >= 11 && abs <= 19) return many;
  if (mod10 === 1) return one;
  if (mod10 >= 2 && mod10 <= 4) return few;
  return many;
};

const label = computed(() => {
  const n = countEl.value ?? 0;
  return `${n} ${pluralize(
    n,
    String(i18n.global.t("confirm_elements_one")),
    String(i18n.global.t("confirm_elements_few")),
    String(i18n.global.t("confirm_elements_many")),
  )}`;
});

const MODAL_WIDTH = 235;
const MODAL_HEIGHT_FALLBACK = 160;
const MODAL_MARGIN = 8;

const getCenteredPosition = (): ModalPosition => ({
  x: window.scrollX + (window.innerWidth - MODAL_WIDTH) / 2,
  y: window.scrollY + (window.innerHeight - MODAL_HEIGHT_FALLBACK) / 2,
});

const safePosition = computed<ModalPosition | null>(() => {
  if (
    isMobile.value &&
    ["remove", "removeFile", "removeFolder", "error"].includes(props.type)
  ) {
    return null;
  }

  const raw = props.position;

  const position =
    raw &&
    Number.isFinite(raw.x) &&
    Number.isFinite(raw.y) &&
    !(raw.x === 0 && raw.y === 0)
      ? raw
      : getCenteredPosition();

  const minX = window.scrollX + MODAL_MARGIN;
  const minY = window.scrollY + MODAL_MARGIN;

  const maxX = window.scrollX + window.innerWidth - MODAL_WIDTH - MODAL_MARGIN;

  const maxY =
    window.scrollY + window.innerHeight - MODAL_HEIGHT_FALLBACK - MODAL_MARGIN;

  return {
    x: Math.min(Math.max(position.x, minX), maxX),
    y: Math.min(Math.max(position.y, minY), maxY),
  };
});

const success = () => {
  switch (props.type) {
    case "replace":
      emit("successReplace", selectedReplaceOption.value);
      $modal.value?.onClose();
      break;

    case "move":
      emit("successMove", targetDir.value);
      $modal.value?.onClose();
      break;

    case "replaceUpload":
      emit("successReplaceUpload", selectedReplaceOption.value);
      $modal.value?.onClose();
      break;

    case "remove":
      emit("successRemove");
      $modal.value?.onClose();
      break;

    case "removeFile":
      emit("successRemoveFile", targetDir.value, targetFile.value);
      $modal.value?.onClose();
      break;

    case "removeFolder":
      emit("successRemoveFolder", targetDir.value);
      $modal.value?.onClose();
      break;

    case "abortFile":
      emit("successAbortFile");
      $modal.value?.onClose();
      break;

    case "error":
      emit("closeError");
      $modal.value?.onClose();
      break;
  }

  $modal.value?.onClose();
};

const chooseError = () => {
  switch (props.errorType) {
    case "size":
      errorText.value = String(i18n.global.t("file_error_max_size"));
      break;

    case "extension":
      errorText.value = String(i18n.global.t("file_error_formats_mismatch"));
      break;

    case "folder":
      errorText.value = String(i18n.global.t("file_error_external_folder"));
      break;

    case "notFound":
      errorText.value = String(i18n.global.t("file_not_found"));
      break;

    case "folderNameMatch":
      errorText.value = String(i18n.global.t("file_folder_name_exists"));
      break;

    case "fileNameMatch":
      errorText.value = String(i18n.global.t("file_name_exists"));
      break;

    case "chooseAccessDenied":
      errorText.value = String(i18n.global.t("file_error_partial_access"));
      break;
  }

  // $modal.value?.onClose();
};

onMounted(() => {
  window.addEventListener("keydown", handleEsc, true);
});

onUnmounted(() => {
  window.removeEventListener("keydown", handleEsc, true);
});

const handleEsc = async (e: KeyboardEvent) => {
  if (e.key !== "Escape" && e.key !== "Enter") {
		return
  }
  if (e.repeat) {
		return
  }
  if (!isActive.value) {
		return
  }

  const active = document.activeElement;
  if (e.key === "Enter" && active instanceof HTMLButtonElement) {
		return
  }

  e.stopPropagation();

  if (e.key === "Enter") {
		e.preventDefault();
		success();
		return
  }

  $modal.value?.onClose();
};

const onClose = () => {
  isActive.value = false;
  $modal.value?.onClose();
};

const onOpen = async (dir?: FolderOut, count?: number, file?: FileOut) => {
  try {
    $modal.value?.onOpen();
    isActive.value = true;

    await nextTick();

    targetDir.value = dir;
    targetFile.value = file;
    countEl.value = count;

    if (props.type == "error") {
      chooseError();
    }
  } catch (e) {
    console.error(e);
  }
};

defineExpose({ onOpen, onClose });
</script>

<style scoped lang="scss">
@import "@/styles/color.scss";

.contact-info {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 6px;
  gap: 8px;

  &-modal {
    padding: 12px;
    gap: 16px;
  }

  &__header {
    display: flex;
    text-align: center;
    width: 100%;
    gap: 8px;
    justify-content: center;
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0%;
    color: $color-text_main;
  }

  &__field {
    font-size: 14px;
    line-height: 18px;
    color: $color-text_main;
    flex-direction: column;
    display: flex;
    gap: 10px;

    &-radio {
      display: flex;
      flex-direction: column;
      gap: 2px;
    }

    &--text {
      text-align: center;
      display: inline-block;
      font-size: 14px;
      line-height: 18px;
      letter-spacing: 0%;
      font-weight: 400;
      color: $color-text_main;

      &-weight {
        word-break: break-word;
        font-weight: 500;
        color: $color-text_main;
        font-size: 14px;
        line-height: 18px;
      }
    }

    &--buttons {
      justify-content: center;
      display: flex;
      gap: 8px;

      &-weight {
        font-weight: 500;
      }
    }

    &--col {
      display: flex;
      flex-direction: column;
    }

    &-name {
      font-weight: 500;
    }

    &-value-col {
      display: inline-flex;
      align-items: center;
      &-time {
        color: #979797;
      }

      &-action {
        margin-left: 2px;
      }

      &-show-more {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        height: 16px;
        padding: 2px 4px;
        font-size: 10px;
        border-radius: 8px;
        margin-left: 6px;
        margin-top: 1px;
        background-color: #f2f2f2;
        color: #979797;
        cursor: pointer;
      }

      &-link {
        font-size: 14px;
        line-height: 16px;
        color: #499259;
        text-decoration: none;
        margin-bottom: 4px;

        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
}
</style>
